import React, { useState, useEffect } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

const AboutUs = () => {
  // State to manage form fields

  //  Year start

  const circles = [2001, 2007, 2015, 2017, 2019, 2024]; // Array of circle texts
  const associatedTexts = [
    "In 2001, Madura Mercerisers India Private Limited was founded with a vision to enhance the knitted garment industry by delivering premium fabrics. The company invested in state-of-the-art mercerizing, padding, and drying equipment, setting a high standard in fabric processing. This advanced machinery allowed for the production of superior quality fabrics, providing added value to clients in the knitted garment sector. The commitment to utilizing cutting-edge technology underscored Madura Mercerisers' dedication to excellence from its inception. By focusing on quality and innovation, the company established a strong foundation for future growth and success in the textile industry.",
    "In 2007, Madura Mercerisers expanded its services by introducing garment washing capabilities, complemented by the installation of an Effluent Treatment Plant (ETP). This development enabled the company to offer comprehensive garment processing solutions while adhering to environmental regulations. The ETP ensured that wastewater generated during the washing processes was treated effectively, minimizing environmental impact. This initiative reflected the company's commitment to sustainable practices and environmental stewardship. By integrating garment washing services with responsible waste management, Madura Mercerisers enhanced its value proposition to clients and reinforced its dedication to corporate social responsibility.",
    "In 2015, Madura Mercerisers took a significant step forward by integrating the Ferraro tubular compacting machine into our production line. This advanced equipment is renowned for its efficiency and precision in processing tubular knitted fabrics. The Ferraro compactor enhances fabric stability, reduces shrinkage, and imparts a superior finish, ensuring that our products meet the highest quality standards. By adopting this technology, we reinforced our commitment to delivering premium fabrics to our clients. This investment not only improved our production capabilities but also aligned with our mission to stay at the forefront of textile innovation. The Ferraro compactor's state-of-the-art features allowed us to optimize our processes, resulting in increased efficiency and product excellence. This strategic move underscored our dedication to continuous improvement and our focus on providing the best possible products to the knitted garment industry.",
    "In 2017, Madura Mercerisers expanded its capabilities by establishing a dedicated fabric washing facility. This addition enabled us to offer comprehensive pre-treatment processes, ensuring that our fabrics are impeccably clean and primed for subsequent finishing stages. Alongside this development, we undertook a significant boiler upgrade to enhance our energy efficiency and support the increased demands of our operations. The new boiler system provided a more reliable and efficient energy source, reducing our environmental footprint and operational costs. These advancements allowed us to maintain stringent quality control measures, ensuring that every fabric piece meets our exacting standards. By investing in these critical infrastructure improvements, we demonstrated our commitment to operational excellence and our dedication to delivering superior products to our clients.",
    "In 2019, Madura Mercerisers upgraded its production capabilities by integrating the Sintec open-width compacting machine from Italy. This advanced equipment processes knitted fabrics in open-width format, ensuring superior dimensional stability, exceptional compaction, and a premium hand feel. We further enhanced our operations with a Kranz stenter for precise fabric width control and uniform drying, alongside an Erhardt+Leimer slit opener for smooth tubular fabric processing. These investments allowed us to achieve consistent fabric quality, minimize distortions, and meet diverse client demands. By adopting these state-of-the-art technologies, we reinforced our commitment to innovation, quality, and efficiency, ensuring our fabrics meet the highest industry standards and remain competitive in the global textile market.",
    "In 2024, Madura Mercerisers reaffirmed its commitment to environmental sustainability by upgrading our Effluent Treatment Plant (ETP) and implementing a Zero Liquid Discharge (ZLD) system. These advancements ensure that our manufacturing processes minimize environmental impact by treating and recycling wastewater, resulting in no liquid waste discharge. The upgraded ETP employs advanced treatment technologies to remove contaminants effectively, while the ZLD system facilitates the complete recovery and reuse of water within our operations. This initiative aligns with global environmental standards and reflects our dedication to responsible manufacturing practices. By adopting these sustainable solutions, we not only protect natural resources but also set a benchmark for environmental stewardship in the textile industry. This strategic move underscores our ongoing commitment to sustainability and our responsibility towards the environment and future generations.",
  ]; // Array of associated texts
  const [activeCircle, setActiveCircle] = useState(0); // Default to first circle
  const [isAutoRotating, setIsAutoRotating] = useState(true); // Track if auto-rotation is active
  const circleCount = circles.length;

  // Automatically increment activeCircle every 5 seconds
  useEffect(() => {
    if (isAutoRotating) {
      const interval = setInterval(() => {
        setActiveCircle((prevActiveCircle) =>
          prevActiveCircle === circleCount - 1 ? 0 : prevActiveCircle + 1
        );
      }, 10000); // 5 seconds

      // Cleanup the interval on component unmount
      return () => clearInterval(interval);
    }
  }, [circleCount, isAutoRotating]);

  // Handle manual circle click, stopping the auto-rotation
  const handleCircleClick = (index) => {
    setActiveCircle(index);
    setIsAutoRotating(false); // Stop the auto-rotation on click
  };

  // Year end

  const teamMembers = [
    {
      name: "K.A.V. Dhandapani",
      role: "Chairman",
      imageSrc: "/MaduraLogo.svg",
    },
    {
      name: "D. Ravichandran",
      role: "Executive Director",
      imageSrc: "/Ravi.jpg",
    },
    {
      name: "D. Rajesh",
      role: "Director",
      imageSrc: "/Rajesh.jpg",
    },
    { name: "A. Bathrinath", role: "CEO", imageSrc: "/MaduraLogo.svg" },
    {
      name: "R.Srivari Krishna",
      role: "Chief Operations",
      imageSrc: "/Srivari.jpg",
    },
    {
      name: "R. Kalishwar Adhish",
      role: "Operations",
      imageSrc: "/MaduraLogo.svg",
    },
    {
      name: "Manigandan",
      role: "General Manager",
      imageSrc: "/MaduraLogo.svg",
    },
  ];

  return (
    <div className="bg-white pt-20 font-poppins">
      {/* Version2 */}
      <div className="flex w-full h-auto">
        {/* First column - 60% width */}
        <div className="w-full h-auto  p-10 md:p-12 md:w-[60%] lg:w-[50%]  md:mb-0  mt-3 md:mt-0   ">
          <p className="tracking-extra-wide text-red-500 ">About Us</p>
          <p className="text-3xl font-bold mb-4 mt-6">
            Holistic Manufacturing Excellence
          </p>
          <p className="text-lg mt-3 ">
            Our facility boasts comprehensive in-house fabric processing
            technologies, including mercerizing, stentering, washing, and
            compacting, ensuring top-notch quality control. We use advanced
            machinery from renowned manufacturers in Germany, Italy, and Taiwan,
            enhancing precision and efficiency. We uphold environmental
            sustainability with our Zero Liquid Discharge (ZLD) and Effluent
            Treatment Plant (ETP). Our commitment to timely delivery is
            supported by rigorous inspections. We collaborate with certified
            vendors for specialized solutions, serving over 300 global clients,
            including leading brands, with a high customer return rate.
          </p>
        </div>

        {/* Second column - 40% width */}
        <div className="hidden  h-auto md:block w-[40%] lg:w-[50%]     object-fit   ">
          <div className="h-full flex items-center justify-center ">
            <img
              src="/AboutUs1.jpg" // Replace with your image URL
              alt="AboutUs"
              className=" object-fit h-[60%]" // Adjusts height to fit the column
            />
          </div>
        </div>
      </div>
      <div className="block md:hidden p-8 w-full  object-fit   ">
        <img
          src="/AboutUs1.jpg" // Replace with your image URL
          alt="AboutUs"
          className=" object-cover " // Adjusts height to fit the column
        />
      </div>
      {/* Version 2 end */}
      <div className="flex bg-[#F6F4F2] ">
        <div className="w-full  md:w-[60%] p-10">
          <p className="tracking-extra-wide text-red-500">Our Timeline</p>
          <p className="font-semibold text-3xl md:text-5xl mt-6 ">
            Madura Journey through time
          </p>
          {/* Circle test start */}
          <div className="flex mt-8 ">
            <div className=" w-[70px]   ">
              {circles.map((year, index) => (
                <React.Fragment key={index}>
                  {/* Circle */}
                  <div
                    onClick={() => handleCircleClick(index)}
                    className={`w-12 h-12  text-xs rounded-full flex items-center justify-center border-2 cursor-pointer transition-transform transform duration-300 
              ${
                activeCircle === index
                  ? "bg-[#1E1A18] text-white scale-110 border-black"
                  : "bg-white text-black scale-100 border-black"
              }
            `}
                  >
                    {year}
                  </div>

                  {/* Dot between circles (skip for the last circle) */}
                  {index < circles.length - 1 && (
                    <div
                      className={`text-black font-bold text-xl ml-[1.4rem] mb-1 transition-opacity duration-500 ${
                        isAutoRotating && activeCircle === index
                          ? "opacity-100 blink"
                          : "opacity-100"
                      }`}
                    >
                      ·
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="w-[100%]  pl-2">
              {/* Display associated text start */}
              {activeCircle !== null && (
                <div className="text-lg text-black">
                  {associatedTexts[activeCircle]}
                </div>
              )}
              {/*  Display associated text end */}
            </div>
          </div>
          {/* Circle test end */}
        </div>
        {/* Right column start */}
        <div className="w-[40%] hidden md:block ">
          <div className="w-[60%]  ml-auto justify-end">
            {" "}
            <a href="/" className="mx-12 ">
              <img src="/Dots.svg" alt="Logo" className="h-12" />
            </a>
          </div>
          <a href="/" className="mx-12 ">
            <img
              src="/timelinePhoto.png"
              alt="Logo"
              className="h-auto p-6 mt-14"
            />
          </a>
        </div>
        {/* Right column end */}
      </div>
      {/* Table start */}
      <div class="tracking-extra-wide text-red-500 w-full text-center mt-9">
        What we offer
      </div>
      <div class="font-extrabold text-3xl w-full text-center mt-6">
        Manufacturing Capacity
      </div>
      {/* <div className="block md:hidden p-6">
        <div className=" border-2 border-black p-4 rounded-lg flex flex-col space-y-2">
          <p className="font-bold">Title: asdf</p>
          <p>Role: asdf</p>
          <div className="flex items-center justify-center w-full">
            <button className="bg-red-500 text-white p-2 w-[60%] rounded-full  ">
              Apply
            </button>
          </div>
        </div>
        <div className=" mt-4 border-2 border-black p-4 rounded-lg flex flex-col space-y-2">
          <p className="font-bold">Title: asdf</p>
          <p>Role: asdf</p>
          <div className="flex items-center justify-center w-full">
            <button className="bg-red-500 text-white p-2 w-[60%] rounded-full  ">
              Apply
            </button>
          </div>
        </div>
      </div> */}
      <div className=" bg-white p-12 md:pl-36 md:pr-36">
        <table className="w-full border-collapse">
          {/* <thead>
            <tr>
              <th className="w-[50%] text-xl  p-2 bg-white text-left">
                Machine
              </th>
              <th className="w-[50%] text-xl text-left p-2 bg-white ">
                Capacity
              </th>
            </tr>
          </thead> */}
          <tbody>
            {/* Row 1 */}
            <tr className="bg-white">
              <td className="text-left p-2 font-bold ">Mercerising</td>
              <td className="text-left  p-2">6 Tons a day.</td>
            </tr>
            {/* Row 2 */}
            <tr className="bg-[#f6f4f2]">
              <td className="text-left p-2 font-bold">Stenter</td>
              <td className="text-left p-2">10 tons a day.</td>
            </tr>
            {/* Row 3 */}
            <tr className="bg-white">
              <td className="text-left p-2 font-bold">Dryer</td>
              <td className="text-left p-2">6 Tons a day.</td>
            </tr>
            {/* Row 4 */}
            <tr className="bg-[#f6f4f2]">
              <td className="text-left p-2 font-bold">Washing</td>
              <td className="text-left p-2">6 Tons a day.</td>
            </tr>
            {/* Row 5 */}
            <tr className="bg-white">
              <td className="text-left p-2 font-bold">Tubular Compacting </td>
              <td className="text-left p-2">6 Tons a day.</td>
            </tr>
            {/* Row 6 */}
            <tr className="bg-[#f6f4f2]">
              <td className="text-left p-2 font-bold">Open Width Compacting</td>
              <td className="text-left p-2">8 Tons a day.</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Table end */}
      <div className=" w-full overflow-x-auto ">
        <div class="tracking-extra-wide text-red-500 w-full pl-6 pt-6 md:pl-24 ">
          The Board
        </div>
        <div class="font-extrabold text-3xl w-full mt-3 mb-6  pl-6 md:pl-24 md:-pt-12 ">
          Pioneering Leadership at Madura
        </div>
        <div className=" flex flex-col items-center justify-center md:flex  md:flex-row md:flex-wrap md:justify-start md:items-start gap-6 p-6 -mt-6 md:-mt-6 md:pl-24 mb-14 ">
          {teamMembers.map((member, index) => (
            <div key={index} className="flex flex-col items-center  ">
              <img
                src={member.imageSrc}
                alt={member.name}
                className="w-full h-54   md:w-48 md:h-48 object-fit mb-2"
              />
              <h3 className="text-sm font-semibold text-center">
                {member.name}
              </h3>
              <p className="text-xs text-gray-600 text-center">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
